/**
 * WarningBox Component
 *
 * Reusable warning/alert box component.
 */

import React from "react";
import { commonStyles, colors } from "../styles";

const WarningBox = ({ title, children, style = {} }) => (
  <div style={{ ...commonStyles.warningBox, ...style }}>
    {title && (
      <div
        style={{
          fontWeight: 600,
          color: colors.warningText,
          marginBottom: "10px",
          fontSize: "14px",
        }}
      >
        {title}
      </div>
    )}
    {children}
  </div>
);

/**
 * WarningList Component
 *
 * A list inside a warning box
 */
export const WarningList = ({ items }) => (
  <ul
    style={{
      margin: 0,
      paddingLeft: "20px",
      color: colors.warningText,
      fontSize: "13px",
      lineHeight: "1.6",
    }}
  >
    {items.map((item, idx) => (
      <li key={idx}>{item}</li>
    ))}
  </ul>
);

export default WarningBox;
